export default "__VITE_ASSET__BgeyekLH__"